import {i18n} from "@/plugins/i18n";

export const contractTemplateType = {
    PF: 1,
    // CASPIAN: 2
};
export const contractTemplateTypeStr = {
    PF: i18n.t('online_contract.types.pf'),
    // CASPIAN: i18n.t('online_contract.types.caspian'),

    get(status) {
        let status_str = null;
        Object.keys(contractTemplateType).forEach(function (item) {
            if(contractTemplateType[item] === status) {
                status_str = contractTemplateTypeStr[item]
            }
        })

        return status_str
    }
};